<template>

  <div id="ViewConsultationDataContainer" class="vs-con-loading__container">


    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-card class="cardx view-consultation">

          <div class="vx-row">
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <div class="mb-4">
                <p class="consultation-label" v-text="$t('consultant_name')"></p>
                <div class="mt-1">
                  <p class="consultation-value" v-text="consultationFormData.consultant_name"></p>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <div class="mb-4">
                <p class="consultation-label" v-text="$t('business_person')"></p>
                <div class="mt-1">
                  <p class="consultation-value" v-text="consultationFormData.assigned_agent.name"></p>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <div class="mb-4">
                <p class="consultation-label" v-text="$t('classification')"></p>
                <div class="mt-1">
                  <p class="consultation-value" v-text="consultationFormData.division.name"></p>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <div class="mb-4">
                <p class="consultation-label" v-text="$t('treatment_result')"></p>
                <div class="mt-1">
                  <p class="consultation-value" v-text="consultationFormData.result_type.name"></p>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <div class="mb-4">
                <p class="consultation-label" v-text="$t('big')"></p>
                <div class="mt-1">
                  <p class="consultation-value" v-text="consultationFormData.big_type.name"></p>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <div class="mb-4">
                <p class="consultation-label" v-text="$t('middle_class')"></p>
                <div class="mt-1">
                  <p class="consultation-value" v-text="consultationFormData.small_type.name"></p>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full" v-for="(customField, key) in customFields" v-bind:key="key">
              <div class="mb-4" :key="key">
                <p class="consultation-label" v-text="customField.title"></p>
                <div class="mt-1">
                  <p class="consultation-value" v-text="consultationFormData.custom_fields_form_data[key].value"></p>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mb-4">
                <p class="consultation-label" v-text="$t('consulting_title')"></p>
                <div class="mt-1">
                  <p class="consultation-value" v-text="consultationFormData.title"></p>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mb-4">
                <p class="consultation-label" v-text="$t('consultation_contents')"></p>
                <div class="mt-1">
                  <p class="consultation-value" v-text="consultationFormData.content"></p>
                </div>
              </div>
            </div>
          </div>

        </vs-card>

      </div>
    </div>
  </div>

</template>

<script>
import Consultation from '@/models/Consultation'
import { EventBus } from '@/../eventbus.js'

export default {
  name: 'Shared.Consultations.Consultations.View',
  data () {
    return {
      memberId: 0,
      consultationId: 0,

      consultationFormData: {
        id: '',
        title: '',
        content: '',
        assigned_agent_id: '',
        division_id: '',
        result_type_id: '',
        big_type_id: '',
        small_type_id: '',
        consultant_name: '',
        assigned_agent: {},
        division: {},
        result_type: {},
        big_type: {},
        small_type: {},
        custom_fields_for_data: []
      },
      consultationFormDataErrors: {},

      customFields: {},
      divisionOptions: [],
      resultOptions: [],
      extensionOptions: [],
      bigOptions: [],
      smallOptions: []
    }
  },
  mounted () {
    EventBus.$on('initLoadViewConsultation', this.initLoadViewConsultation)
  },
  methods: {
    async initLoadViewConsultation (data) {
      this.$vs.loading({container: '#ViewConsultationDataContainer'})

      this.memberId = data.id
      this.consultationId = data.consultationId

      try {

        const consultationResponse = await Consultation.viewConsultation({ id: this.memberId, consultationId: this.consultationId })

        this.consultationFormData = consultationResponse.data.data
        this.divisionOptions = consultationResponse.data.meta.options.divisions
        this.resultOptions = consultationResponse.data.meta.options.results
        this.extensionOptions = consultationResponse.data.meta.options.extensions
        this.bigOptions = consultationResponse.data.meta.options.bigs
        this.smallOptions = consultationResponse.data.meta.options.smalls
        this.customFields = consultationResponse.data.meta.custom_fields

      } catch (e) {
        this.$swalHelper.error({
          title: '',
          text: e.response.data.message,
          confirmButton: this.$t('confirm')
        })
      }

      this.$vs.loading.close('#ViewConsultationDataContainer > .con-vs-loading')

    }
  }
}

</script>

<style lang="scss" scoped>
.view-consultation {
  .consultation-label {
    font-size: 10px;
    color: #7f7f7f;
  }
  .consultation-value {
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
